<template>
  <div class="is-main-content">
    <div class="columns">
      <div class="column ">
        <div>
          <div class="container is-fluid">
            <div class="columns">
              <div class="column is-9-fullhd is-7-desktop is-6-tablet">
                <div class="content">
                  <h3 class="level">Paramétrage</h3>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <br>
          <div class="section">
            <div class="columns">
              <div class="column">
              </div>
              <div class="column is-4 columns">
                <div class="column is-12">
                  <div class="field is-grouped is-pulled-right">
                      <p class="control">
                      <button class="button is-primary"
                              @click="enregistrerParametrage()">
                        Enregistrer paramétrage
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            </div>
          <div class="container is-fluid">
            <table>
              <thead>
                <tr>
                  <th class="columnNom">Nom du paramètre
                  </th>
                  <th>
                    Valeur Boolean
                  </th>
                  <th>
                    Valeur String
                  </th>
                </tr>
              </thead>
            <tbody>
              <tr :key="id" v-for="(parametre,id)  in parametrages">
                <td>{{parametre.cle}}</td>
                <td>
                  <b-switch v-model="parametre.valeurBoolean"
                      type="is-primary">
                  </b-switch>
                </td>
                <td>
                  <input class="input" v-model="parametre.valeurString">
                </td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>
        <div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import gestionErreur from '@/services/general/gestionErreur';
import { PAGE_DEFAULT } from '@/router/routerConf';
import toastConfirmation from '@/services/general/toastConfirmation';

const Parametrages = createNamespacedHelpers('parametrage');
const user = createNamespacedHelpers('user');

export default {
  name: 'page',
  components: {
  },
  computed: {
    ...Parametrages.mapGetters({
      parametrages: 'parametrages',
    }),
    ...user.mapGetters({
      isSupport: 'isSupport',
    }),
  },
  methods: {
    ...Parametrages.mapActions({
      actionsRechercheParametrages: 'rechercheParametrages',
      actionsSauvegardeParametrages: 'sauvegardeParametrages',
    }),
    enregistrerParametrage() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.actionsSauvegardeParametrages(this.parametrages).then(() => {
        loadingComponent.close();
        toastConfirmation('Paramètre bien enregistré');
      }).catch((e) => {
        gestionErreur('Erreur de l\'enregistrement des parametres', e);
        loadingComponent.close();
      });
    },
  },
  mounted() {
    if (this.isSupport) {
      this.actionsRechercheParametrages();
    } else {
      const vm = this;
      vm.$router.push(PAGE_DEFAULT);
    }
  },
};
</script>

<style scoped lang="scss">

table {
  border: 2px solid #42b983;
  border-radius: 2px;
  background-color: #fff;
  font-size: 14px;
}

th {
  background-color: #42b983;
  color: rgba(255,255,255,0.66);
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

td {
  background-color: #f9f9f9;
  border: 1px solid #42b983;;
}

input {
  width: 500px;
}

th, td {
  min-width: 110px;
  padding: 10px 10px;
}

.columnNom
{
  width: 300px
}

</style>



// WEBPACK FOOTER //
// src/components/general/parametrage.vue